var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Strong, Trans, translate, useToastService, } from '@lucidlink/uicore';
import { PII_MASK_CLASS } from '#constants';
import { useWorkspaceLeave } from '#query-hooks';
import { workspaceRoutes } from '#services';
import { ModalActions, ModalDescription, ModalTitle } from './components';
export const WorkspaceLeaveModal = ({ closeModal, workspaceId, workspaceName, }) => {
    _react_refresh_temp_2();
    const titleId = useId();
    const navigate = useNavigate();
    const { addToast } = useToastService();
    const { mutation: { isPending, mutate: leaveWorkspace }, } = useWorkspaceLeave(workspaceId, {
        onError: () => {
            addToast({
                content: {
                    message: translate('You were unable to leave {{workspaceName}} workspace.', { workspaceName }),
                },
                kind: 'negative',
                'data-testid': 'warning-workspace-leave',
            });
        },
        onSuccess: () => {
            addToast({
                content: {
                    message: translate('You successfully left the {{workspaceName}} workspace.', { workspaceName }),
                },
                kind: 'positive',
                'data-testid': 'success-workspace-leave',
            });
            closeModal();
            void navigate(workspaceRoutes.workspaces());
        },
    });
    const onConfirm = () => {
        leaveWorkspace();
    };
    return (_jsxs(Modal, { "aria-labelledby": titleId, closeModal: closeModal, children: [_jsx(ModalTitle, { id: titleId, children: _jsxs(Trans, { shouldUnescape: true, values: { workspaceName }, children: ["Are you sure you want to leave the", _jsx("br", {}), _jsx(Strong, { className: PII_MASK_CLASS, wordBreak: "breakWord", children: '{{workspaceName}}' }), ' ', "workspace?"] }) }), _jsx(ModalDescription, { children: _jsx(Trans, { children: "You will lose access to all information associated with this workspace." }) }), _jsxs(ModalActions, { children: [_jsx(Button, { "data-testid": "cancel-workspace-leave", isFullWidth: true, kind: "secondary", onClick: closeModal, size: "big", children: _jsx(Trans, { children: "Cancel" }) }), _jsx(Button, { "data-testid": "confirm-workspace-leave", isFullWidth: true, isLoading: isPending, kind: "primary", onClick: onConfirm, size: "big", children: _jsx(Trans, { children: "Yes, leave" }) })] })] }));
};
_react_refresh_temp_1 = WorkspaceLeaveModal;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceLeaveModal");
_react_refresh_temp_2(WorkspaceLeaveModal, "I9NQIBjmw7N8Kzl7OpgNilqbv0M=", false, () => [useNavigate, useToastService, useWorkspaceLeave]);
